import { gsap } from "gsap";

class NavBarMobileMenu {
    constructor(node, config) {
        let self = this;
        self.node = node;
        self.config = config;

        self.behaviour();
    }

    behaviour() {
        let self = this;

        if (self.isMobile()) {
            self.initMainMenu();
        }
        else {
            if(! self.config.hover) {
                self.initSubMenu('desktop');
            }
        }
    }

    reInit() {
        let self = this;

        if (! self.isMobile() && self.config.hover) {
            return;
        }

        self.closeMainMenu();
        self.closeAllDropDownMenu();
        self.destroyMainMenu();
        self.destroySubMenu();
        self.behaviour();
    }

    initMainMenu() {
        let self = this;
        self.initSubMenu();
        self.navbarButton = document.querySelector('.js-menu-button');
        self.navbarContent = self.node.querySelector('.js-navbar-content');

        self.toggleMainMenuReference = self.toggleMainMenu.bind(null, self);
        self.navbarButton.addEventListener('click', self.toggleMainMenuReference, false);
    }

    destroyMainMenu() {
        let self = this;

        if(self.navbarButton) {
            self.navbarButton.removeEventListener('click',  self.toggleMainMenuReference, false);
        }
    }

    toggleMainMenu(self) {
        
        self.navbarContent.dataset.opened === "true" ? self.closeMainMenu() : self.openMainMenu();
    }

    openMainMenu() {
        let self = this;

        self.navbarButton.classList.add('open');
        self.navbarContent.dataset.opened = "true";
        self.navbarContent.classList.remove('hidden');
        document.querySelector('body').classList.add('overflow-hidden');
        gsap.from(self.navbarContent, {duration: 0.4, autoAlpha:0, right: '-100%'});
    }

    closeMainMenu() {
        let self = this;

        if(! self.isMobile() && self.config.hover === true) {
            return;
        }
       
        if(self.navbarButton && self.navbarButton.classList.contains('open')) {
            self.navbarButton.classList.remove('open');
            document.querySelector('body').classList.remove('overflow-hidden');
        }

        if(self.navbarContent && self.navbarContent.dataset.opened === 'true') {
            
            gsap.to(self.navbarContent, {duration: 0.5, autoAlpha:0, right: '-100%', onComplete:function() {
                self.navbarContent.dataset.opened = "false";
                self.navbarContent.classList.add('hidden');
                self.navbarContent.removeAttribute('style');
            }});

        }

        if(! self.dropDownNodes) {
                return;
        }

        if (self.dropDownNodes.length && self.dropDownListeners.length) {
            
            self.closeAllDropDownMenu();
        }
    }

    initSubMenu(device) {
        let self = this;

        self.dropDownNodes = self.node.querySelectorAll('[data-is-dropdown="true"]');
        self.dropDownListeners = [];
        self.toggleDropDownMenuReference = self.toggleDropDownMenu.bind(null, self, device);

        self.dropDownNodes.forEach((node, index) => {
            self.dropDownListeners[index] = node.querySelector('[data-toggle="dropdown"]');
            self.dropDownListeners[index].addEventListener('click', self.toggleDropDownMenuReference, false);
        });
    }

    destroySubMenu() {
        let self = this;

        if (self.dropDownListeners) {
            self.dropDownListeners.forEach(element => {
                element.removeEventListener('click', self.toggleDropDownMenuReference, false);
            });
        }
    }

    toggleDropDownMenu(self, device) {
        let button = event.target.closest('a');
        let dropDown = button.parentElement.querySelector('[data-dropdown-opened]');

        dropDown.dataset.dropdownOpened === "true" ? self.closeDropDownMenu(dropDown): self.openDropDownMenu(dropDown);

        if (device === 'desktop') {
            let allDropDown = self.node.querySelectorAll('[data-dropdown-opened="true"]');

            if (allDropDown.length > 1) {
                allDropDown.forEach(dropDown => {
                    if (dropDown.closest('ul') === event.target.closest('ul')) {
                        if (dropDown.closest('[data-is-dropdown="true"]') !== event.target.closest('[data-is-dropdown="true"]')) {
                            self.closeDropDownMenu(dropDown);
                        }

                        if (dropDown.querySelectorAll('[data-dropdown-opened="true"]').length >= 1) {
                            dropDown.querySelectorAll('[data-dropdown-opened="true"]').forEach(elem => {
                                self.closeDropDownMenu(elem);
                            })
                        }
                    }
                });
            }
        }
    }

    openDropDownMenu(dropDown) {
        dropDown.parentElement.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'true');
        dropDown.classList.remove('hidden');
        dropDown.dataset.dropdownOpened = "true";
    }

    closeDropDownMenu(dropDown) {
        dropDown.parentElement.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
        dropDown.classList.add('hidden');
        dropDown.dataset.dropdownOpened = "false";
    }

    closeAllDropDownMenu() {
        let self = this;

        if(! self.dropDownNodes) {
            return;
        }

        self.dropDownNodes.forEach(node => {
            let dropDown = node.querySelector('[data-dropdown-opened]');
            if (dropDown.dataset.dropdownOpened === "true") {
                self.closeDropDownMenu(dropDown);
            }
        });
    }

    isMobile() {
        let self = this;
        return window.innerWidth < self.config.mobile;
    }
}

const navBarMobileMenu = {
    navbar: null,
    timeout: false, // holder for timeout id
    delay: 250, // delay after event is "complete" to run callback
    initValue: null,

    init() {
        let self = this;

        let node = document.querySelector('.js-navbar');
        self.initValue = window.innerWidth;

        if (node) {
            self.navbar = new NavBarMobileMenu(node, {
                hover: true,
                mobile: 992,
            });
        }
    },

    reInit(self) {

        if(! self) {
            self = this;        
        }

        if (self.navbar) {
            self.navbar.closeMainMenu();
        }
        
        let value = window.innerWidth;
        let reInit = false;

        if(self.initValue >= 992 && value < 992) {
            self.initValue = 992;
            reInit = true;
        }
        
        if(self.initValue < 992 && value > 992) {
            self.initValue = 993;
            reInit = true;
        }

        if(reInit) {
            self.navbar.reInit();
        }
    },
};

window.navBarMobileMenu = navBarMobileMenu;

window.navBarMobileMenu.init();

window.addEventListener('resize', function() {
    clearTimeout(navBarMobileMenu.timeout);
    window.navBarMobileMenu.timeout = setTimeout(window.navBarMobileMenu.reInit.bind(null, window.navBarMobileMenu), window.navBarMobileMenu.delay);
});


document.addEventListener('LokiRequestEnd', function () {
    if(window.navBarMobileMenu.navbar) {
        window.navBarMobileMenu.navbar.closeMainMenu();
    }
   
    window.navBarMobileMenu.init();
});


